import type {
  CarrierStateBookingPanel,
  CarrierBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/carriersBookingPanel';

export const get = (state: CarrierStateBookingPanel, id: number): CarrierBookingPanel =>
  state.byId[id];
export const getAll = (state: CarrierStateBookingPanel): Record<number, CarrierBookingPanel> =>
  state.byId;
